import { createPopoverPlugin } from './popover.js'

export { createPopoverPlugin }



// WEBPACK FOOTER //
// ./src/public/plugins/popover/index.js